import m from "../../geodata/es2015/continentsRussiaEuropeHigh";
window.am4geodata_continentsRussiaEuropeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaEuropeHigh.js
// module id = null
// module chunks = 